import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";
import {PrecisionByNumberPipe} from "./precision-by-number.pipe";

@Pipe({
  name: 'numberFixed'
})
export class NumberFixedPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe, private precisionByNumberPipe: PrecisionByNumberPipe) {
  }

  transform(value: number, precision: number): string | null {
    if (value == null) {
      return null;
    }
    let number = this.precisionByNumberPipe.transform(precision);
    const fixedNumber = this.toFixed(value, number);
    let format = this.formatByPrecision(number+1);
    //console.log(value, number, fixedNumber, format, result);
    return this.decimalPipe.transform(fixedNumber, format);
  }

  toFixed(num, fixed) {
    const re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    let regExpMatchArray = num.toString().match(re);
    if(regExpMatchArray?.length > 0){
      return regExpMatchArray[0];
    }
    return 0;
  }

  formatByPrecision(number: number) {
    switch (number) {
      case 0:
        return '1.6-6';
      case 1:
        return '1.5-5';
      case 2:
        return '1.4-4';
      case 3:
        return '1.3-3';
      case 4:
        return '1.2-2';
      case 5:
        return '1.1-1';
      case 6:
        return '1.0-0';
      case 7:
        return '1.0-0';
    }
  }
}
